import axios from 'axios';
import { withFreshAuth } from './freshAuth';

const buildClient = (baseURL) => {
  const c = axios.create({
    baseURL,
    headers: { 'Content-Type': 'application/json' },
  });
  c.interceptors.request.use(withFreshAuth);
  return c;
};

export const transcribeService = {
  async cancelTask(baseUrl, taskId) {
    if (!baseUrl || !taskId) return null;
    try {
      const r = await buildClient(baseUrl).delete(`/task/${taskId}`);
      return r.data;
    } catch (err) {
      // 404 (задача давно почищена) или сетевая — глотаем,
      // локальный abort всё равно отработает.
      return null;
    }
  },
};
